import { createFileRoute } from "@tanstack/react-router";
import { TrainingHistory } from "@/features/training-history/training-history.ui";

const HistoryPage = () => <TrainingHistory />;

export const Route = createFileRoute("/history")({
  component: HistoryPage,
});
